import { IInsuranceContract, IProductGroup, ProductGroupType } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';
import { BaseViewModel } from 'src/app/common/viewmodel/base-view-model';
import type { TreeProductGroupViewModel } from './tree-productgroup-viewmodel';

export class BaseProductGroupViewModel extends BaseViewModel implements IProductGroup {
  number: number;
  medicalAidPositionNumber: string;
  name: string;
  description: string;
  type: ProductGroupType;
  parentId: string;
  attributeTemplateIds: string[];
  _id: string;
  timestamp: Date;
  archived: boolean;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;

  @ignore()
  billing: string;
  @ignore()
  possibleContracts: IInsuranceContract[] = [];
  @ignore()
  selectedContract: IInsuranceContract;
  @ignore()
  children: TreeProductGroupViewModel[];
  @ignore()
  collapsed: boolean;
  @ignore()
  allContractsAreFlatCharge: boolean;

  public isContractSelectionNecessary(): boolean {
    if (!this.possibleContracts || this.possibleContracts.length === 0) {
      return false;
    }

    if (this.possibleContracts.length === 1) {
      this.selectedContract = this.possibleContracts[0];
      return false;
    }
    return true;
  }
}
